import * as React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export function ConfirmButton() {
    return (
        <StyledButton
            type="submit"
            variant="contained"
            aria-label="Confirm setup"
        >
            Bestätigen
        </StyledButton>
    );
}

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '100px',
    backgroundColor: '#93c11f',
    boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.75)',
    alignSelf: 'stretch',
    marginTop: '30px',
    minHeight: '56px',
    width: '100%',
    color: theme.palette.common.black,
    textAlign: 'center',
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: 400,
    border: '2px solid #501de8',
    padding: '10px 24px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#7da319'
    },
    '&:focus-visible': {
        outline: `3px solid ${theme.palette.primary.main}`,
        outlineOffset: '2px'
    }
}));